import types from './types';

export const defaultEpnOrdersState = {
  dlist: {
    loading: false,
    data: null,
    error: null
  }
};

const epnOrdersReducer = (state = defaultEpnOrdersState, action) => {
  switch (action.type) {
    case types.EPN_DLIST_SET_LOADING:
      return {
        ...state,
        dlist: {
          ...state.dlist,
          loading: action.payload
        }
      };

    case types.EPN_DLIST_SET_DATA:
      return {
        ...state,
        dlist: {
          ...state.dlist,
          data: action.payload,
          error: null
        }
      };

    case types.EPN_DLIST_SET_ERROR:
      return {
        ...state,
        dlist: {
          ...state.dlist,
          error: action.payload,
          data: null
        }
      };

    case types.EPN_DLIST_CLEAR_DATA:
      return {
        ...state,
        dlist: {
          loading: false,
          data: null,
          error: null
        }
      };

    default:
      return state;
  }
};

export default epnOrdersReducer;
